module.exports = __webpack_public_path__ + "components/flag/static/square/vg-105032d57ab4cb5e0505ea91a9c67a7c.svg";